/**
 * @generated SignedSource<<1ba58cf88d2dfe63fcdb29b1b754a6a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type TeeSheet_HeaderData$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly clientClass: ClientClass | null | undefined;
      readonly club: {
        readonly facilities: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly courses: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                    readonly name: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly department: {
                readonly type: DepartmentType;
              } | null | undefined;
              readonly id: string;
              readonly maxMultipleBookings: number | null | undefined;
              readonly multipleBookingsEnabled: boolean;
              readonly name: string;
              readonly slug: string;
              readonly waitlistRestrictions: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly id: string;
                  } | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly " $fragmentSpreads": FragmentRefs<"AgendaDateSelectorControlFragment_facility" | "TeeSheetAgendaSidebarFragment_facility" | "TeeSheetBasedFiltersModalFragment_facility" | "WaitlistModalFragment_Facility" | "getFacilityMemberPermissions_facility" | "useGetBookingWindowDaysByFacilityId">;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaHeaderDesktopNewFragment_club" | "TeeSheetAgendaHeaderMobileNewFragment_club" | "useResetTeeSheetFilters_club">;
      };
      readonly id?: string;
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly email?: string | null | undefined;
    readonly id?: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaSidebar_session" | "TeeSheetBasedFiltersModal_session">;
  readonly " $fragmentType": "TeeSheet_HeaderData";
};
export type TeeSheet_HeaderData$key = {
  readonly " $data"?: TeeSheet_HeaderData$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheet_HeaderData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheet_HeaderData",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetAgendaSidebar_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeeSheetBasedFiltersModal_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "type": "MemberUser",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Customer",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientClass",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeeSheetAgendaHeaderDesktopNewFragment_club"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeeSheetAgendaHeaderMobileNewFragment_club"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useResetTeeSheetFilters_club"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityConnection",
                  "kind": "LinkedField",
                  "name": "facilities",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FacilityEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "slug",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "maxMultipleBookings",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "multipleBookingsEnabled",
                              "storageKey": null
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "useGetBookingWindowDaysByFacilityId"
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "getFacilityMemberPermissions_facility",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Club",
                                  "kind": "LinkedField",
                                  "name": "club",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "supportsPrivate",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "supportsPublic",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PublicBookingPermissionSet",
                                  "kind": "LinkedField",
                                  "name": "publicBookingPermissionSet",
                                  "plural": false,
                                  "selections": (v3/*: any*/),
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PrivateBookingPermissionSet",
                                  "kind": "LinkedField",
                                  "name": "privateBookingPermissionSet",
                                  "plural": false,
                                  "selections": (v3/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "WaitlistModalFragment_Facility"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TeeSheetAgendaSidebarFragment_facility"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TeeSheetBasedFiltersModalFragment_facility"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "AgendaDateSelectorControlFragment_facility"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CourseConnection",
                              "kind": "LinkedField",
                              "name": "courses",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "CourseEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Course",
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": [
                                        (v2/*: any*/),
                                        (v0/*: any*/)
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Department",
                              "kind": "LinkedField",
                              "name": "department",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "type",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": "waitlistRestrictions",
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "type",
                                  "value": [
                                    "WAITLIST"
                                  ]
                                }
                              ],
                              "concreteType": "BookingRuleConnection",
                              "kind": "LinkedField",
                              "name": "bookingRules",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "BookingRuleEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": null,
                                      "kind": "LinkedField",
                                      "name": "node",
                                      "plural": false,
                                      "selections": (v1/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "d27f7d754ccd9a454cf1c0cb3bc1a543";

export default node;
